import { createAsyncThunk } from '@reduxjs/toolkit';
import { errorGlobal, successGlobal } from "../reducers/notifications";
import axios from 'axios';
import { getAuthHeader, removeTokenCookie } from '../../utils/tool';
import { LOGIN, ISAUTH} from '../../endPoints.js';




export const signInUser = createAsyncThunk(
    'users/signInUser',
    async ({ email, password }, { dispatch }) => {
        try {
            const request = await axios.post(`${LOGIN}`, {
                userEmail: email,
                password: password
            });

            if(!request.data.token){
                throw new Error(request.data.msg);
            }


            const motivationalThoughts = [
                "Today is a new opportunity to make progress.",
                "Every day is a fresh start; let's make it count.",
                "Hard work brings closer the success I seek.",
                "Morning brings new energy to achieve my goals.",
                "The path to success is built one step at a time.",
                "The challenges of today are the victories of tomorrow.",
                "My work is a reflection of my passion and purpose.",
                "Each small effort adds up to significant results.",
                "I am capable, confident, and ready for success.",
                "A positive attitude creates positive results.",
                "The first step is always the hardest—just take it!",
                "My creativity shines through every task I complete.",
                "Success is the sum of small efforts repeated daily.",
                "Focus and persistence are my strengths.",
                "Today, I will conquer my goals.",
                "I am in control of my thoughts and productivity.",
                "Each task brings me closer to achieving my dreams.",
                "Progress, not perfection, is what matters.",
                "I am capable of more than I imagine.",
                "Hard work opens doors to new opportunities.",
                "I will use my time today wisely and efficiently.",
                "Every challenge is a chance to grow and learn.",
                "Today, I will achieve something great.",
                "I choose positivity and reject negativity.",
                "I am driven by passion, not by fear.",
                "The more I do, the closer I get to my dreams.",
                "I am making progress, even if it's just a little each day.",
                "I can handle any task, big or small.",
                "Success is built by daily discipline.",
                "Today is another step toward my long-term goals.",
                "My work ethic today determines my success tomorrow.",
                "I am focused, determined, and relentless.",
                "I am in charge of my success and happiness.",
                "I choose to be productive and engaged.",
                "My efforts today will be rewarded in the future.",
                "With every task, I am sharpening my skills.",
                "I embrace the power of momentum.",
                "I am proud of what I can achieve today.",
                "I have the power to create positive change.",
                "Today, I will go the extra mile.",
                "Challenges are just stepping stones to success.",
                "Each day is a chance to become better.",
                "I am disciplined, motivated, and focused.",
                "Every accomplishment starts with the decision to try.",
                "Today, I will be my most productive self.",
                "Small actions, big results.",
                "I am shaping my future with the work I do today.",
                "Success doesn't come overnight, but it comes with perseverance.",
                "My work matters, and I am making an impact.",
                "Today is full of possibilities and potential.",
                "I will turn challenges into opportunities.",
                "I wake up with purpose and determination.",
                "Every task completed brings me closer to my goals.",
                "I am committed to giving my best effort.",
                "I am stronger and more capable than I realize.",
                "With hard work and focus, I can achieve anything.",
                "I am building a better future for myself with each task I complete.",
                "My work is valuable and meaningful.",
                "Each morning is a chance to set the tone for the day.",
                "I will bring my best energy to the day ahead.",
                "The journey to success begins today.",
                "I am making progress even when it feels slow.",
                "I am grateful for the work I get to do.",
                "I am confident in my ability to overcome any obstacles.",
                "Success is earned one day at a time.",
                "My productivity today sets the foundation for tomorrow.",
                "Today is the perfect day to take action.",
                "I am grateful for another day to work toward my dreams.",
                "I am inspired by the possibilities that today holds.",
                "I am the creator of my own success.",
                "I have everything I need to succeed today.",
                "I am persistent, patient, and proactive.",
                "Every minute spent working today is an investment in my future.",
                "I will focus on progress, not perfection.",
                "I am committed to growing and improving every day.",
                "My efforts today will pay off in the long run.",
                "I will stay focused and productive throughout the day.",
                "Today is full of endless possibilities.",
                "I am determined to make the most of this day.",
                "I have the power to turn challenges into opportunities.",
                "My goals are within reach, and I will work toward them today.",
                "I am building a future I am proud of.",
                "Today, I will step out of my comfort zone.",
                "Every step I take brings me closer to my dreams.",
                "I will use this day as an opportunity to grow.",
                "I am in control of how productive I am today.",
                "I will embrace the challenges that come my way.",
                "The work I put in today will lead to my success.",
                "I am motivated, focused, and ready to succeed.",
                "I am capable of achieving my goals, one task at a time.",
                "I will be proud of the work I do today.",
                "I choose to make today a productive day.",
                "I will approach each task with positivity and determination.",
                "I am driven by the desire to succeed.",
                "Today, I will make things happen.",
                "Every action I take today leads me toward success.",
                "I am thankful for the opportunity to work and grow today.",
                "I will make the most out of today, no matter the challenges.",
                "I will tackle every task with enthusiasm and focus."
              ];
              
            console.log(request.data);

            dispatch(successGlobal("Welcome!! " + request.data.userName + `\n \n \n  ${motivationalThoughts[Math.floor(Math.random() * motivationalThoughts.length)]}`))
            return { data: request.data, auth: true }
        } catch (error) {
            dispatch(errorGlobal(error.message))
            throw error;
        }
    }
)

export const isAuth = createAsyncThunk(
    'users/isauth',
    async() => {
        try{    
            const request = await axios.get(`${ISAUTH}=${getAuthHeader()}`,);
            if(!request.data.userEmail){
                throw new Error(request.data.msg);
            }
            return { data: request.data, auth: true}
        }catch(error){
            return { data: {}, auth: false}
        }
    }
)

export const signOut = createAsyncThunk(
    'users/signout',
    async() => {
        removeTokenCookie();
    }
)


